import React from "react";
import Teamimage from "./Images/Team.svg";
import facebook from "./Images/facebook.png";
import insta from "./Images/insta.png";
import linkdin from "./Images/linkdin.svg";
import AditySoni from '../../TeamImages/Aditya_soni.jpg'
import AnilJain from '../../TeamImages/Anil_jain.jpg'
import ArunSharma from '../../TeamImages/arun_sharma.jpg'
import ArvindBatra from '../../TeamImages/Arvind_Batra.jpg'
import AshishBhardwaj from '../../TeamImages/ashish_bharadwaj.jpg'
import Babulalsaini from '../../TeamImages/Babu_lal_saini.jpg'
import Bharvi from '../../TeamImages/Bharvi_Maheshwari.jpg'
import Anjana from '../../TeamImages/Dr._Anjana_verma.jpg'
import saroj from '../../TeamImages/Dr._Saroj_Sharma.jpg'
import Narendra from '../../TeamImages/Dr._Narenda_Singh_Choudhary.jpeg'
import Ganesh from '../../TeamImages/ganesh.jpg'
import Kshitij from '../../TeamImages/Kshitij_choudhary.jpg'
import Piyush from '../../TeamImages/Piyush_Vijayvergiya.jpg'
import Pooja from '../../TeamImages/Pooja_Tosniwal.jpg'
import Pratit from '../../TeamImages/Pratit_Vijayvergia.png'
import Ramnik from '../../TeamImages/RAMNIK_JAIN.jpg'
import Rishi from '../../TeamImages/Rishi_Joshi.jpeg'
import Sachin from '../../TeamImages/sachin golechha.jpg'
import Sanjay from '../../TeamImages/Sanjay_Jaipuria.jpg'

import Sharad from '../../TeamImages/Sharad_Rathi.jpg'
import Shekhar from '../../TeamImages/Shekhar Bansal.jpg'
import Shyam from '../../TeamImages/Shyam Sunder Gupta.jpg'
import Siddhart from '../../TeamImages/Siddarth Tyagi.jpg'
import Sumit from '../../TeamImages/sumit dhadda.jpg'
import Sunil from '../../TeamImages/sunill_sucklecha.jpg'

import Vikas_Sharma from '../../TeamImages/Vikas_Sharma.jpeg'
import Vikas_Solanki from '../../TeamImages/Vikas_Solanki.jpeg'
import Vipan_Bahl from '../../TeamImages/Vipan bahl.jpg'

import Rajamohan from './Images/rajamohan.jpg';
import leonardo from './Images/leonardo.jpeg';
import Mark from './Images/mark.jpg';
import sachin from './Images/sachin_gujar.jpg';

const LeaderShipTeamsRBM = () => {
  const array2 = [
    {
      name: 'Rajamohan Dhandapani',
      position: 'Chair',
      organization: 'Chair',
      ContactNumber: '',
      Email_id: '',
      Linkedin: '#',
      Facebook: '#',
      Description: 'Chair',
      Profile_Picture: `${Rajamohan}`,
    },
    {
      name: 'Arvind Batra',
      position: 'Vice Chair',
      organization: 'Globe Communication',
      ContactNumber: '9214001400',
      Email_id: 'globejpr@gmail.com',
      Linkedin: '#',
      Facebook: '#',
      Description: 'Vice  Chair',
      Profile_Picture: `${ArvindBatra}`,
    },
    {
      name: 'Mark Burchill',
      position: 'Chair Emeritus and Treasurer',
      organization: 'Chair Emeritus and Treasurer',
      ContactNumber: '',
      Email_id: '',
      Linkedin: '#',
      Facebook: '#',
      Description: 'Chair Emeritus and Treasurer',
      Profile_Picture: `${Mark}`,
    },
    {
      name: 'Sachin Gururaj',
      position: 'Chair Emeritus & Immediate Past Chair',
      organization: 'Chair Emeritus & Immediate Past Chair',
      ContactNumber: '',
      Email_id: '',
      Linkedin: '#',
      Facebook: '#',
      Description: 'Chair Emeritus & Immediate Past Chair',
      Profile_Picture: `${sachin}`,
    },
    {
      name: 'leonardo santos',
      position: 'Secretary',
      organization: 'Secretary',
      ContactNumber: '',
      Email_id: '',
      Linkedin: '#',
      Facebook: '#',
      Description: 'Secretary',
      Profile_Picture: `${leonardo}`,
    },
  ];
  const array=[
    
    {
      name:' Ashish Bhardwaj',
      position:' IT & Digital Marketing',
      organization:' Aadvik Tech Services Private Limited',
      ContactNumber:'7301020313',
      Email_id:'Ashish@aadviktech.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'Website and Software Development / Application Development / Digital marketing /IT Consultancy',
      Profile_Picture:`${AshishBhardwaj}`,
    }
    ,
    {
      name:'Babu Lal Saini',
      position:' Uniform Stitching and Shirt Embroidery',
      organization:'Fashion World',
      ContactNumber:' 7014203859',
      Email_id:'fashionworld8926@gmail.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'All type stitching work and uniform with fabric stitching and shirt embroidery',
      Profile_Picture:`${Babulalsaini}`,
    }
    ,
    {
      name:'Bharvi Maheshwari',
      position:'Corporate Events & Destination Wedding',
      organization:'Innovative Events & Weddings',
      ContactNumber:' 9887849950',
      Email_id:'innovativeevents4u@gmail.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'We have Discounted prices for Flights and international tours',
      Profile_Picture:`${Bharvi}`,
    }
    ,
    {
      name:' Dr. Anjana Verma',
      position:'Advocate',
      organization:'Verma & Associates',
      ContactNumber:' 9460449494',
      Email_id:'dranjanaadvocate@gmail.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'Advocate',
      Profile_Picture:`${Anjana}`,
    }
    ,
    {
      name:' Dr.Saroj Raj Sharma',
      position:'H.D.P.E Granules',
      organization:'Chetan plastic',
      ContactNumber:' 6377401332',
      Email_id:'Sharmasaroj011@gmail.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'Deals in H.D.P.E Granules',
      Profile_Picture:`${saroj}`,
    }
    ,
    {
      name:' Dr Narendra Singh Choudhary',
      position:'Colonisers',
      organization:'High Fly Real estate group ',
      ContactNumber:' 9414520171',
      Email_id:'nslvswm@gmail.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'Real estate',
      Profile_Picture:`${Narendra}`,
    }
    ,
    {
      name:' Ganesh Choudhary',
      position:'International & Domestic Tours and Visas',
      organization:'TripFactory Holidays',
      ContactNumber:' 9845005044',
      Email_id:'ganesh@tripfactory.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'We have Discounted prices for Flights and international tours',
      Profile_Picture:`${Ganesh}`,
    }
    ,
    {
      name:' Kshitij Prasad',
      position:' Surveyor and loss assessor ',
      organization:'TripFactory Holidays',
      ContactNumber:' 9314660397',
      Email_id:'Kshitij_prashad@yahoo.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'Insurance claim and consultant',
      Profile_Picture:`${Kshitij}`,
    }
    ,
    {
      name:' Piyush Vijayvergia',
      position:'  Handicrafts and Corporate Gifting',
      organization:'Ciana Crafts Pvt Ltd',
      ContactNumber:' 9461626969',
      Email_id:'piyush.mvj@gmail.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'Ciana Crafts is a brand dedicated to creating beautiful, high-quality wooden handmade items that are designed to last. We specialize in crafting unique pieces that are both functional and beautiful, and we take great pride in the quality of our work.',
      Profile_Picture:`${Piyush}`,
    }
    ,
    {
      name:' Pooja Toshniwal',
      position:' Cake Artist, Baking & Cooking ',
      organization:'The Bake Studio by Pooja ',
      ContactNumber:' 9650155886',
      Email_id:'Pooja.Tosniwal@gmail.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'The Bake Studio by Pooja crafts homemade premium designer cakes from scratch, without premixes or preservatives & is known for its egg-free, 100% vegetarian cakes catering to diverse dietary preferences. In my another venture, Iâ€™m bringing the taste & tradition in the form of Gond Badam Ladoos, with different varieties!',
      Profile_Picture:`${Pooja}`,
    }
    ,
    {
      name:' Pratit Vijayvergiya',
      position:'  Technology Consulting & Business Intelligence ',
      organization:' KodConcept Technologies Pvt Ltd  ',
      ContactNumber:' 9800019995',
      Email_id:'Pratit@kodconcept.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'AUDIO VIDEO PRODUCTS USED FOR HOME THEATRES,AUDITORIUM,SMARTCLAASROOMS,CONFERENCE HALL,PA SYSTEM',
      Profile_Picture:`${Pratit}`,
    }
    ,
    {
      name:'  Ramnik Jain',
      position:'Verve Logic LLP',
      organization:' Verve Logic LLP ',
      ContactNumber:' 9649356615',
      Email_id:'rumnikjain@gmail.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'Verve Logic LLP ',
      Profile_Picture:`${Ramnik}`,
    }
    ,
    {
      name:' Rishi Joshi',
      position:'Industrial and Domestic Packaging',
      organization:'Global Trading company',
      ContactNumber:' 9829854406',
      Email_id:'globetradingjpr@gmail.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'Aluminium Foil rolls and containers Parchment Tissue papers and rolls Bio-Degradable garbage bags Eco friendly table top cutleries (baggase) Compostable bags and films And eco friendly Strecth films All kind industrial packaging Complete solution for eco friendly packaging',
      Profile_Picture:`${Rishi}`,
    }
    ,
    {
      name:' Sachin Golecha',
      position:'Financial planner and Investment consultant',
      organization:'Sachin Golechha ',
      ContactNumber:'  9351450657',
      Email_id:'golechhasachin@gmail.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'Mutual funds ,Equity, Bonds. Retirement planning, Child education Planning , Tax planning.',
      Profile_Picture:`${Sachin}`,
    }
    ,
    {
      name:'  Sanjay Jaipuriya',
      position:' System Integrator For Audio-Video',
      organization:'RAGHAV ENTERPRISES',
      ContactNumber:'   9828013494',
      Email_id:'sanjay@raghaventerprises.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'AUDIO VIDEO PRODUCTS USED FOR HOME THEATRES,AUDITORIUM,SMARTCLAASROOMS,CONFERENCE HALL,PA SYSTEM',
      Profile_Picture:`${Sanjay}`,
    }
    ,
    {
      name:' Sharad Kumar Rathi',
      position:' Web Hosting ,Cloud Hosting , Data Centre',
      organization:' Advika Data Center Services Pvt. Ltd.',
      ContactNumber:' 9928142077',
      Email_id:'sales@awdhpl.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'Web Hosting ,Cloud Hosting , Data Centre',
      Profile_Picture:`${Sharad}`,
    }
    ,
    {
      name:' Shekhar Bansal',
      position:'General Insurance',
      organization:' M S Inserve',
      ContactNumber:' 9829036329',
      Email_id:'vwinnn@gmail.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'General Insurance',
      Profile_Picture:`${Shekhar}`,
    }
    ,
    {
      name:' Shyam sundar gupta',
      position:' Investment consultant ',
      organization:'Indiarise consaltancy',
      ContactNumber:' 9829497788',
      Email_id:'sagginvest@gmail.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'Investment consultant',
      Profile_Picture:`${Shyam}`,
    }
    ,
    {
      name:' Siddhart Tyagi',
      position:' Pest control services',
      organization:' IPCS PEST CONTROL PVT.LTD',
      ContactNumber:'80949 49596',
      Email_id:'siddharthtyagijpr@gmail.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'We deal in pest control and specialize in termite treatment.',
      Profile_Picture:`${Siddhart}`,
    }
    ,
    {
      name:' Sumit Dhadda',
      position:' Internal Audit, GST, Valuations ',
      organization:'DLS Associates',
      ContactNumber:'9571704444',
      Email_id:'dhadda.sumit@gmail.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'CA firm services',
      Profile_Picture:`${Sumit}`,
    }
    ,
    {
      name:'Sunil Sukhlecha',
      position:'Silver Jewellery & Gem Stone',
      organization:'Allure Jewellery Pvt.Ltd',
      ContactNumber:'9829056762',
      Email_id:'s.sucklecha@gmail.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'We deals in colour Gems Stones & Silver Jewellery',
      Profile_Picture:`${Sunil}`,
    }
    ,
    {
      name:' Vikas Sharma',
      position:'Advertising & Promotion ',
      organization:'Indush Media & Entertainment LLP',
      ContactNumber:'9636025555',
      Email_id:'sharmavikas87@gmail.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'We deal into all kinds of advertising and promotions of your brand. 360 degree promotions available.',
      Profile_Picture:`${Vikas_Sharma}`,
    }
    ,
    {
      name:'Vikas Solanki',
      position:' Digital Marketing and Mobile Apps  ',
      organization:'Doomshell Softwares Pvt Ltd',
      ContactNumber:' 9829732221',
      Email_id:'Vikas@doomshell.com',
      Linkedin:'#',
      Facebook:'#',
      Description:'Digital Marketing and Mobile Apps Development',
      Profile_Picture:`${Vikas_Solanki}`,
    }
    ,
    {
      name:'Vipan Bahl',
      position:' Computers And Cloud Solutions  ',
      organization:'BB PROFESSIONALS Computers And Electronics Pvt Ltd',
      ContactNumber:' 9828113447',
      Email_id:'VB@BBP.IN',
      Linkedin:'#',
      Facebook:'#',
      Description:'HP, Apple, Microsoft (Computers, Printers, Plotters, Printers, Scanners, Multifunction, Workstations, Data Storage, Cloud Computing, Servers, Networking)',
      Profile_Picture:`${Vipan_Bahl}`,
    }

  ];
  return (
    <div>
      <div className="bg-[#101729] py-14 px-[8%] ">
        <div className="flex flex-wrap w-[100%] justify-between ">
          <div className=" sm:w-[50%]">
            <span className="text-[39px] leading-10	font-bold	text-[#F1F4F9] ml-2">
              Leadership{" "}
            </span>
            <span className="text-[#FDBC12] text-[39px] leading-10	font-bold	">
              Team
            </span>
          </div>
        </div>
        <div>
          <div className="w-[100%] flex flex-wrap justify-between mt-[70px] gap-y-10 ">
          {array2.map((data, index) =>(
            <div className=" flex flex-wrap lg:w-[48%] w-[100%] gap-4">
            <div className=" w-[200px] h-[200px] p-3 border-2 border-[#FDBC12] rounded-full flex justify-center items-center">
                <img className=" w-full h-full rounded-full object-cover" src={data.Profile_Picture} alt="" />
            </div>
            <div className=" sm:w-[60%] w-[100%] flex flex-col justify-center sm:mt-0 mt-4">
            <h5 className="sm:text-[24px] text-[18px] font-semibol text-[#F5F5F5]">{data.name}</h5>
            <p className="text-[14px] font-semibol text-[#D7D3D2]">{data.position}</p>
            <div className="w-[171px] h-[2px] bg-[#FDBC12] mt-5"></div>
            <p className="text-[12px] text-[#94A2B8] mt-5 h-[95px]">{data.Description}</p>
            <div className="flex items-center mt-3">   <img className="w-[24px] h-[24px] " src={facebook} alt="" />
            <img className="w-[24px] h-[24px] ml-4" src={insta} alt="" onClick={()=>{
              window.location.href=`${data.Facebook}`
            }}/>
            <img className="w-[24px] h-[24px]  ml-4" src={linkdin} alt="" onClick={()=>{
              window.location.href=`${data.Linkedin}`
            }} />
            <button className="bg-[#FDBC12] w-[150px] py-2 rounded text-[#101729] text-[12px] font-normal ml-4">
            Connect With Me
            </button>

            </div>
            </div>
           
         
          </div>
          ))}
          </div>
        </div>
        <div>
          
        </div>
      </div>
    </div>
  );
};

export default LeaderShipTeamsRBM;
